import { ReactNode, useCallback, useState } from 'react';
import { GrantInfoHelpPanel } from '../components/events/createEvent/components/GrantInfoHelpPanel';
import { ShiftTypeInfoHelpPanel } from '../components/events/createEvent/components/ShiftTypeInfoHelpPanel';
import { CommunityOrganizationHelpPanel } from '../components/events/createEvent/components/CommunityOrganizationHelpInfo';
import { WaitlistInfoHelpPanel } from '../components/myActivity/waitlistInfoHelpPanel';
import { CoordinatorNotificationHelpPanel } from '../components/events/createEvent/components/CoordinatorNotificationHelpPanel';

type PanelId =
  | 'grant'
  | 'shiftType'
  | 'communityOrganization'
  | 'waitlist'
  | 'coordinatorNotification';

const PANELS: Record<PanelId, () => ReactNode> = {
  grant: () => <GrantInfoHelpPanel />,
  shiftType: () => <ShiftTypeInfoHelpPanel />,
  communityOrganization: () => <CommunityOrganizationHelpPanel />,
  waitlist: () => <WaitlistInfoHelpPanel />,
  coordinatorNotification: () => <CoordinatorNotificationHelpPanel />,
};

export function useWizardToolsPanel() {
  const [toolsOpen, setToolsOpen] = useState(false);
  const [panelId, setPanelId] = useState<PanelId>('grant');

  const openPanel = useCallback((id: PanelId) => {
    setPanelId(id);
    setToolsOpen(true);
  }, []);

  const close = useCallback(() => setToolsOpen(false), []);

  const openGrantPanel = useCallback(() => openPanel('grant'), [openPanel]);
  const openShiftTypePanel = useCallback(() => openPanel('shiftType'), [openPanel]);
  const openCommunityOrganizationPanel = useCallback(
    () => openPanel('communityOrganization'),
    [openPanel]
  );
  const openWaitlistPanel = useCallback(() => openPanel('waitlist'), [openPanel]);
  const openCoordinatorNotificationPanel = useCallback(
    () => openPanel('coordinatorNotification'),
    [openPanel]
  );

  const onToolsChange = useCallback(
    ({ detail }: { detail: { open: boolean } }) => setToolsOpen(detail.open),
    []
  );

  return {
    toolsOpen,
    toolsHide: !toolsOpen,
    tools: PANELS[panelId](),
    onToolsChange,
    openGrantPanel,
    openShiftTypePanel,
    openCommunityOrganizationPanel,
    openWaitlistPanel,
    openCoordinatorNotificationPanel,
    close,
  };
}
